import { useNavigate } from 'react-router-dom';
import styled from 'styled-components';
import { ampli } from '../../ampli';
import { Icon } from '../../components/common/icon/Icon';
import { useLayout } from '../../hooks/screen/useLayout';
import { postMessageToRN } from '../../utils/RNCommunicator/postMessageToRN.util';
import { CustomerReviewSection } from './components/CustomerReviewSection';
import { DriveModeSection } from './components/DriveModeSection';
import { KitDetailsSection } from './components/KitDetailsSection';
import { GlobalVerificationPromoSection } from './components/GlobalVerificationPromoSection';
import { RTKGPSSection } from './components/RTKGPSSection';
import { RequestConsultSection } from './components/RequestConsultSection';
import { TopSection } from './components/TopSection';
import { TrustSafetySection } from './components/TrustSafetySection';
import { UserGuideSection } from './components/UserGuideSection';
import { MainHead } from '../../components/common/head/MainHead';
import ReactGA from 'react-ga4';

export const PluvaAutoLandingPage = () => {
  const navigate = useNavigate();

  const handlePluvaAutoInquiryButton = () => {
    ampli.오토플루바오토문의하기버튼클릭({
      page_type: 'landing',
    });
    ReactGA.event('pvm_click_pluva_auto_inquiry_button');
    if (window.ReactNativeWebView) {
      postMessageToRN({ messageKey: 'link', messageParam: 'tel:15335502' });
    } else {
      window.location.href = 'tel:15335502';
    }
  };

  useLayout({
    fixedHeader: <MainHead backButton={{ isShow: true }} headerTitle={'플루바 오토'} />,
    fixedFooter: (
      <ButtonContainer>
        <BlurredSection />

        <BottomButton onClick={handlePluvaAutoInquiryButton}>
          <BottomButtonText>{'플루바 오토 문의하기 1533-5502'}</BottomButtonText>
        </BottomButton>
      </ButtonContainer>
    ),
    fixedHeaderHeight: 48,
  });

  return (
    <Container>
      <TopSection />

      <CustomerReviewSection />

      <RTKGPSSection />

      <GlobalVerificationPromoSection />

      <DriveModeSection />

      <KitDetailsSection />

      <TrustSafetySection />

      <RequestConsultSection />

      <UserGuideSection />
    </Container>
  );
};

const Container = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
`;

const HeaderSection = styled.div`
  display: flex;
  height: 40px;
  padding: 0px var(--radius-large, 16px);
  justify-content: space-between;
  align-items: center;
  align-self: stretch;
`;

const BackButton = styled.button``;

const HeaderTitleWrapper = styled.div`
  display: flex;
  height: 20px;
  justify-content: center;
  align-items: center;
  gap: var(--radius-medium, 8px);
  flex: 1 0 0;
`;

const HeaderTitle = styled.h1`
  color: var(--Light-Scheme-Monochrome-black, #232429);
  text-align: center;

  /* Display/Large/l-bold */
  font-family: Pretendard;
  font-size: 16px;
  font-style: normal;
  font-weight: 700;
  line-height: 130%; /* 20.8px */
`;

const ButtonContainer = styled.div`
  width: 100%;
  max-width: 512px;

  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;

  padding: 0px 16px;
  padding-bottom: 32px;

  gap: 8px;

  background-color: white;

  position: relative;
`;

const BlurredSection = styled.div`
  width: 100%;
  height: 40px;

  display: flex;
  justify-content: center;
  align-items: center;

  padding: var(--radius-large, 16px);
  gap: var(--radius-small, 4px);

  border-radius: var(--radius-none, 0px);
  background: linear-gradient(180deg, rgba(255, 255, 255, 0) 0%, #fff 63.96%);

  position: absolute;
  top: -40px;
`;

const BottomButton = styled.button`
  width: 100%;
  height: 40px;

  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;

  gap: 8px;

  border-radius: var(--radius-medium, 8px);
  background: var(--Light-Scheme-Color-primary-blue, #445eff);
`;

const BottomButtonText = styled.span`
  color: var(--Light-Scheme-Monochrome-white, #fff);

  /* System/Medium/m-medium */
  font-family: Pretendard;
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: 85%; /* 11.9px */
`;

const GreyButton = styled.button`
  width: 100%;
  height: 40px;

  display: flex;
  justify-content: center;
  align-items: center;

  padding: 16px;

  gap: 4px;

  border-radius: var(--radius-medium, 8px);
  background: var(--Light-Scheme-Monochrome-grey10, #f2f2f7);
`;

const GreyButtonText = styled.span`
  color: var(--Light-Scheme-Monochrome-grey100, #858894);

  /* System/Medium/m-medium */
  font-family: Pretendard;
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: 85%; /* 11.9px */
`;
